<template>
  <div class="overlay-media-container" :style="'height:'+height+';width:'+width">
    <div class="overlay-media-tb">
      <div class="overlay-media-tbc">
        <center>
          <div v-if="!evaluated">
            <h3 class="text-white">Califica este curso</h3>
            <br />
            <div v-if="!loading" class="stars-container mt-5">
              <i
                v-for="i in 5"
                :key="i"
                @click="calificarCurso(i)"
                @mouseover="hoverStar(i)"
                @mouseleave="leaveStar"
                :class="['fa-star star',{'star-c  fas':i<=starsC},{'far':i>starsC}]"
              ></i>
            </div>
            <div v-else>
              <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
            <div class="stars-container mt-5">
              <p @click="closeWindow" class="text-warning" style="cursor:pointer;margin-top:25px">
                <center>En otro momento</center>
              </p>
            </div>
          </div>
          <div v-else>
            <h3 class="text-white">Muchas gracias por tu evaluación</h3>
          </div>
        </center>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: String,
    width: String,
    stars: Number,
    course_id: Number
  },
  mounted() {
    this.starsC = this.stars;
  },
  data() {
    return {
      starsC: 0,
      loading: false,
      evaluated: false
    };
  },
  methods: {
    calificarCurso(stars) {
      this.loading = true;
      let url = "course/" + this.course_id + "/evaluate";
      this.api
        .post(url, {
          data: {
            stars: stars
          }
        })
        .then(({ data }) => {
          this.loading = false;
          this.evaluated = true;
          setTimeout(() => {
            this.bus.$emit("EvaluateCourse", stars);
          }, 2000);
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });

      this.$forceUpdate();
    },
    hoverStar(star) {
      this.starsC = star;
    },
    leaveStar() {
      this.starsC = this.stars;
    },
    closeWindow() {
      this.bus.$emit("CloseEvaluate", false);
    }
  }
};
</script>

<style scoped>
.overlay-media-container {
  transition: all 300ms ease;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  position: absolute;
}

.overlay-media-tb {
  height: 100%;
  width: 100%;
  display: table;
}
.overlay-media-tbc {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
}

.stars-container { 
  display: inline;
}

.star {
  color: orange;
  font-size: 40px;
  margin-left: 20px;
  cursor: pointer;
  transition: 300ms all ease;
}

.star-c {
  color: orange;
  transition: 300ms all ease;
}
</style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/CourseEvaluation.vue